<template>
  <div>
    <div v-if="cq.percentComplete !== 1 || (coupon.unclipped===true && cq.percentComplete === 1)" class="closeness-qualifier mb-2" @click="openCouponDetailModal(coupon.couponId)">
      <div>
        <div class="closeness-qualifier__icon-in-progress"></div>
      </div>
      <div class="closeness-qualifier__info">
        <div class="closeness-qualifier__title-in-progress">{{cq.callToAction}}</div>
        <div class="closeness-qualifier__progress"></div>
          <b-progress :value="cq.percentComplete * 100" variant="coupon-in-progress" height="12px"></b-progress>
        <div v-if="description" class="closeness-qualifier__description" v-html="cq.name"></div>
      </div>
    </div>

    <div v-if="cq.percentComplete === 1 && coupon.unclipped === false" class="closeness-qualifier mb-2" @click="openCouponDetailModal(coupon.couponId)">
      <div>
        <div class="closeness-qualifier__icon-success"></div>
      </div>
      <div class="closeness-qualifier__info">
        <div class="closeness-qualifier__title-success">{{cq.callToAction}}</div>
        <b-progress :value="100" variant="success" height="12px"></b-progress>
        <div v-if="description" class="closeness-qualifier__description" v-html="cq.name"></div>
      </div>
    </div>

  </div>
</template>

<script>
import { BProgress } from 'bootstrap-vue'

export default {
  name: 'ClosenessQualifier',
  props: {
    cartItem: {
      type: Object
    },
    cq: {
      type: Object
    },
    coupon: {
      type: Object
    },
    itemIndex: {
      type: Number
    },
    //Toggles the description below the closeness qualifier bar, currently only true for cart
    description: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'b-progress': BProgress
  },
  data () {
    return {
    }
  },
  methods: {
    openCouponDetailModal: function(couponId){
      if(typeof couponId === 'undefined') {
        console.log("There is no couponId associated.")
        return
      }


      if(this.$route && this.$route.query.modalId == 'sparkle'){
        // are we in the sparkle modal? 
        // If so, when the user closes the modal, they will be sent back to the sparkle modal instead of closing. (anti pattern)
        this.hupOpenModal({modalId: 'coupon-detail', couponId: couponId, closeAction: 'back'})
      }else if(this.$route){
        // not in the sparkle, maybe in a SPA cart item 
        this.hupOpenModal({modalId: 'coupon-detail', couponId: couponId, closeAction: 'back'})
      }else{
        // in the non spa app
        this.$store.commit('profile/OPEN_MODAL', {
        id: 'coupon-detail',  
        options: {couponId: couponId}
      })
        // this.hupOpenModal({modalId: 'coupon-detail', couponId: couponId})
      }
      this.gtmClickCoupon('e_couponDetails', this.coupon, 1)
    }
  },
  computed: {

  }
}
</script>

<style lang="scss">
@import "../assets/lib";

.closeness-qualifier {
  display: flex;
  cursor: pointer;
  // padding: .5rem 0;

  // closeness-qualifier__info
  &__info{
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    flex-grow: 1;
    flex-basis: 100%;
    text-align: left;
  }

  // closeness-qualifier__title-in-progress
  &__title-in-progress {
    font-weight: 600;
    text-decoration: underline;
    margin-bottom: 4px;
  }

  // closeness-qualifier__title-success
  &__title-success {
    font-weight: 600;
    font-style: italic;
    color: green;
    margin-bottom: 4px;
  }

  // closeness-qualifier__description
  &__description {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #4A4A4A;
  }

  .bg-coupon-in-progress{
    background-color: #E8A915;
  }

  .closeness-qualifier__icon-in-progress {
    width: 28px;
    height: 28px;
    background: url('https://images.heb.com/is/image/HEBGrocery/closeness-qualifier-sprite@2x?$article$') no-repeat 0 -28px;
    background-size: 28px;
  }

  .closeness-qualifier__icon-success {
    width: 28px;
    height: 28px;
    background: url('https://images.heb.com/is/image/HEBGrocery/closeness-qualifier-sprite@2x?$article$') no-repeat;
    background-size: 28px;
  }

  &__description{
    margin-top: 4px;
  }
}

@media screen and (min-width: $breakpoint-desktop){
    // closeness-qualifier__info @medium
  .closeness-qualifier {
    &__info{
      max-width: 250px;
    }
  }
}
</style>

<docs>
</docs>
